module.exports = __webpack_public_path__ + "static/media/covi_too_cle_fre.e4113046.png";